var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 24,
    viewBox: "0 0 31 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.9375 3.78668V20.9957C0.9375 22.1412 1.5726 23.0161 2.39096 23.5796C3.40132 24.2754 4.43647 23.7038 5.23066 23.0587C7.70188 21.0515 10.502 18.9959 12.9206 17.0141C13.1729 16.8074 13.3715 16.655 13.6396 16.4539C13.9027 16.2567 14.1099 16.0751 14.3517 15.8867C14.6039 15.6902 14.7955 15.506 15.0932 15.3489C15.0932 17.1864 15.1002 19.0254 15.0916 20.8628C15.0873 21.7924 15.3961 22.3633 15.8046 22.9077C16.2265 23.4699 16.8695 23.8862 17.6547 23.8862C18.7325 23.8862 20.4136 22.2013 21.3427 21.5141L24.7789 18.8236C25.3563 18.3546 25.8983 17.9531 26.4694 17.4844L28.171 16.1563C29.7574 14.9476 30.7317 14.3845 30.7317 12.1894C30.7317 10.1407 28.8962 9.25119 27.3768 8.00611C27.0756 7.7594 26.8094 7.57481 26.506 7.32847L19.6858 1.96272C18.9338 1.36441 17.788 0.347828 16.5467 1.20268C16.2389 1.41471 16.0282 1.57643 15.8046 1.87442C15.3854 2.43325 15.087 2.96491 15.0916 3.9195C15.1002 5.75687 15.0932 7.59584 15.0932 9.43333C14.8804 9.37663 14.6479 9.12673 14.39 8.92454C11.7869 6.88512 8.40295 4.30924 5.94123 2.29231C5.01016 1.52933 3.71147 0.29347 2.39108 1.20281C2.10152 1.40229 1.87609 1.57385 1.67767 1.8358C1.29784 2.3372 0.937623 2.90772 0.937623 3.78668H0.9375Z",
    fill: "#ADAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.65cd7b5298fdfeb68ada89d3f01cf388.svg";
export { ForwardRef as ReactComponent };